module.exports = __webpack_public_path__ + "img/DS-J-3.ced34103.svg";